import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Company } from 'components/common/Elements/Elements';
import { recordType } from 'utils/common';
import { useRegionalLink } from 'hooks/useRegionalLink';

const Account = ({ company }) => {
  let { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();

  const {
    customerId,
    companyName,
    status,
    companySize,
    country,
    website,
    poc,
    tenantUUID,
    terminationStatus
  } = company;

  return (
    <NavLink to={generateRegionalPath(`${url}/${company.customerId}/general`)}>
      <Company
        nameCompany={companyName ? companyName : customerId}
        status={status}
        terminationStatus={terminationStatus}
        description={companySize}
        recordType={recordType(company)}
        country={country}
        domain={website}
        addStatus={poc}
        customerId={customerId}
        isCheckpointTenant={tenantUUID && tenantUUID !== 'NA'}
      />
    </NavLink>
  );
};

Account.propTypes = {
  company: PropTypes.object
};

export default Account;
